import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { notificationClose } from "../../../redux/reducers/notification-reducer";
import { useDispatch, useSelector } from "react-redux";

const posizioneSnackbar = { vertical: "top", horizontal: "center" };

const Notification = () => {
  const state = useSelector((state) => state.notification);
  const dispatch = useDispatch();
  const { open } = state;

  const handleClose = (event, reason) => {
    if (reason === "clickaway")
      setTimeout(() => dispatch(notificationClose()), 5000);
    dispatch(notificationClose());
  };

  return (
    <>
      <Snackbar
        open={open}
        autoHideDuration={5000}
        onClose={handleClose}
        anchorOrigin={posizioneSnackbar}
        key={posizioneSnackbar.vertical + posizioneSnackbar.horizontal}
      >
        <Alert onClose={handleClose} severity={state.severity}>
          {state.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default Notification;
